































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RateChangesModule from "@/store/modules/rate-changes";
import { namespace } from "vuex-class";
import { IPRCFilter } from "@/models";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "OccupancyPercentage"
})
export default class OccupancyPercentage extends Vue {
  // ===== Store ===== //
  @rateChanges.Action private applyFilter!: (filter: IPRCFilter) => void;
  // ===== Props ===== //
  @Prop(Number) private readonly filter!: number;
  // ===== Data ===== //
  public occupancyPctMin = "";
  public occupancyPctMax = "";

  // ===== Methods ===== //
  public generateQueryString(): string {
    const queryString: string[] = [];

    if (this.occupancyPctMin && !this.occupancyPctMax) {
      queryString.push(`occupancy_pct[gte]=${this.occupancyPctMin}`);
    } else if (this.occupancyPctMax && !this.occupancyPctMin) {
      queryString.push(`occupancy_pct[lte]=${this.occupancyPctMax}`);
    } else {
      queryString.push(`occupancy_pct[gte]=${this.occupancyPctMin}&occupancy_pct[lte]=${this.occupancyPctMax}`);
    }

    return queryString.join("");
  }

  public generateOccupancyPctParameterChip(): string {
    if (this.occupancyPctMin && !this.occupancyPctMax) {
      return `Occupancy % minimum is >= ${this.occupancyPctMin}%`;
    } else if (this.occupancyPctMax && !this.occupancyPctMin) {
      return `Occupancy % maximum is <= ${this.occupancyPctMax}%`;
    }

    return `Occupancy % minimum is >= ${this.occupancyPctMin}% & maximum is <= ${this.occupancyPctMax}%`;
  }

  @Watch("selectedOccupancyPctParameter", { deep: true })
  public handleSelectedOccupancyPct(selectedOccupancyPctParameter: IPRCFilter): void {
    this.applyFilter(selectedOccupancyPctParameter);
  }
  // ===== Computed ===== //
  get occupancyPctParameterOperator(): string {
    if (this.occupancyPctMin && !this.occupancyPctMax) {
      return "[gte]";
    } else if (this.occupancyPctMax && !this.occupancyPctMin) {
      return "[lte]";
    }
    return "[lte][gte]";
  }

  get selectedOccupancyPctParameter(): IPRCFilter {
    return {
      id: this.filter,
      chipText: this.generateOccupancyPctParameterChip(),
      operator: this.occupancyPctParameterOperator,
      value: `${this.occupancyPctMin}, ${this.occupancyPctMax}`,
      query: this.generateQueryString()
    };
  }
}
